import React, { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

import type { QuoteDataContextValue } from './QuoteDataContext.types'

const QuoteDataContext = createContext<QuoteDataContextValue | undefined>(undefined)

export const QuoteDataProvider = (props: { children: ReactNode; value: QuoteDataContextValue }) => {
  return <QuoteDataContext.Provider value={props.value}>{props.children}</QuoteDataContext.Provider>
}

export const useQuoteData = (): QuoteDataContextValue => {
  const value = useContext(QuoteDataContext)
  if (!value) {
    throw new Error('useQuoteData must be used within a QuoteDataProvider')
  }
  return value
}
